export const BLOG_STATUS = Object.freeze({
  draft: 'draft',
  scheduled: 'scheduled',
  published: 'published',
  unpublished: 'unpublished',
})

export const BLOG_STATUS_LABELS = Object.freeze({
  draft: 'Чернетка',
  scheduled: 'Заплановано',
  published: 'Опубліковано',
  unpublished: 'Знято',
})

export const BLOG_SYSTEM_AUTHOR_ID = 'system:ame'

export const safeBlogHref = (value) => {
  if (typeof value !== 'string') return null
  const href = value.trim()
  return /^(https?:\/\/|mailto:|tel:|\/(?!\/)|#)/i.test(href) ? href : null
}

/** Gallery block layouts — storefront must render all three. */
export const BLOG_GALLERY_LAYOUT = Object.freeze({
  grid: 'grid',
  carousel: 'carousel',
  collage: 'collage',
})

export const BLOG_GALLERY_LAYOUT_OPTIONS = Object.freeze([
  { value: BLOG_GALLERY_LAYOUT.grid, label: 'Сітка' },
  { value: BLOG_GALLERY_LAYOUT.carousel, label: 'Карусель' },
  { value: BLOG_GALLERY_LAYOUT.collage, label: 'Колаж' },
])

export const BLOG_GALLERY_LAYOUT_HINTS = Object.freeze({
  [BLOG_GALLERY_LAYOUT.grid]: 'Рівні плитки в рядах. Добре для 3–12 фото.',
  [BLOG_GALLERY_LAYOUT.carousel]: 'Одне фото крупно + гортання. Добре для довгих серій.',
  [BLOG_GALLERY_LAYOUT.collage]:
    'Готові композиції на 2–6 фото (герой + дрібні). Порядок у списку = порядок у колажі.',
})

export const getBlogStatusLabel = (status) =>
  BLOG_STATUS_LABELS[status] || status || '—'

export const normalizeBlogGalleryLayout = (layout) => {
  if (layout === BLOG_GALLERY_LAYOUT.carousel) return BLOG_GALLERY_LAYOUT.carousel
  if (layout === BLOG_GALLERY_LAYOUT.collage) return BLOG_GALLERY_LAYOUT.collage
  return BLOG_GALLERY_LAYOUT.grid
}
